import { PalmettoIcon, PalmettoLink } from '@palmetto/dsm-components';

import { CustomerDirectPaymentPage } from './CustomerDirectPaymentPage';

export function CustomerDirectPaymentExpiredLink() {
  return (
    <CustomerDirectPaymentPage>
      {/* Main content — top on mobile, centered on desktop */}
      <div className="flex flex-1 items-start justify-center pt-24 lg:items-center lg:pt-40 lg:pb-40">
        <div className="flex w-full max-w-[697px] flex-col items-stretch gap-8 lg:h-[344.5px] lg:flex-row">
          {/* Inactive card */}
          <div
            data-theme="lumen"
            className="flex w-full flex-col justify-between gap-32 rounded-16 bg-canvas-error p-24 lg:w-[340px] lg:shrink-0"
          >
            <h2 className="heading-700 text-text-error">
              Uh oh,
              <br />
              this link is
              <br />
              inactive
            </h2>
            <PalmettoIcon name="clockSquare" size="2xl" className="text-text-error" />
          </div>

          {/* Right column — explanation */}
          <div className="flex flex-1 flex-col gap-16 p-24 lg:justify-center">
            <p className="body-400 text-text-secondary">This payment has been completed, or the link has expired.</p>
            <p className="body-400 text-text-secondary">
              If you still need to make a payment, please{' '}
              <PalmettoLink href="mailto:help@golightreach.com" size="md">
                contact Palmetto support
              </PalmettoLink>
              .
            </p>
          </div>
        </div>
      </div>
    </CustomerDirectPaymentPage>
  );
}
